import React, { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api";
import "../../styles/Login.scss";
import logo from "../../assets/images/safari-logo.svg";

const ForgotPassword = () => {
    const [email, setEmail] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [error, setError] = useState<string>("");

    const handleSubmit = async (
        event: FormEvent<HTMLFormElement>
    ) => {
        event.preventDefault();

        setLoading(true);
        setMessage("");
        setError("");

        try {
            const response = await api.post("/admin/forgot-password", {
                email,
            });

            setMessage(response.data.message);
        } catch (err: any) {
            console.error("Forgot password failed:", err);

            setError(
                err.response?.data?.message ||
                "Unable to send reset link. Please try again."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-card">

                    <div className="login-header">
                        <img src={logo} alt="Safari Vinegar" />
                    </div>

                    <div className="login-content">

                        <p>Reset your password</p>

                        {!message ? (
                            <form onSubmit={handleSubmit}>

                                <div className="form-group">
                                    <label htmlFor="email">
                                        Email
                                    </label>

                                    <input
                                        id="email"
                                        type="email"
                                        value={email}
                                        onChange={(event) =>
                                            setEmail(event.target.value)
                                        }
                                        autoComplete="email"
                                        required
                                        disabled={loading}
                                    />
                                </div>

                                {error && (
                                    <div className="form-error">
                                        {error}
                                    </div>
                                )}

                                <div className="forgot-password-actions">
                                    <Link
                                        to="/admin-login"
                                        className="forgot-password-button"
                                    >
                                        Back to login
                                    </Link>

                                    <button
                                        type="submit"
                                        className="forgot-password-button"
                                        disabled={loading}
                                    >
                                        {loading
                                            ? "Sending..."
                                            : "Send reset link"}
                                    </button>
                                </div>

                            </form>
                        ) : (
                            <>
                                <div className="form-success">
                                    {message}
                                </div>

                                <div className="forgot-password-actions">
                                    <Link
                                        to="/admin-login"
                                        className="forgot-password-button"
                                    >
                                        Back to login
                                    </Link>
                                </div>
                            </>
                        )}

                    </div>

                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
